var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcodeScan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      verticalAlign: "middle",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.666667 256h85.333333v512H170.666667V256m128 0h42.666666v512H298.666667V256m85.333333 0h128v512H384V256m170.666667 0h42.666666v512h-42.666666V256m128 0h85.333333v512h-85.333333V256m128 0h42.666666v512h-42.666666V256M85.333333 170.666667v170.666666H0V170.666667a85.333333 85.333333 0 0 1 85.333333-85.333334h170.666667v85.333334H85.333333m853.333334-85.333334a85.333333 85.333333 0 0 1 85.333333 85.333334v170.666666h-85.333333V170.666667h-170.666667V85.333333h170.666667M85.333333 682.666667v170.666666h170.666667v85.333334H85.333333a85.333333 85.333333 0 0 1-85.333333-85.333334v-170.666666h85.333333m853.333334 170.666666v-170.666666h85.333333v170.666666a85.333333 85.333333 0 0 1-85.333333 85.333334h-170.666667v-85.333334h170.666667z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeScan);
export default __webpack_public_path__ + "static/media/barcode-scan.23ff35f1e8c2d18b358b0b0b05803ee1.svg";
export { ForwardRef as ReactComponent };